<template>
    <v-footer dark padless>
        <v-card flat tile  class="color_main white--text text-center">
            <v-card-text>
                <v-btn
                v-for="(icon, i) in icons"
                :key="i"
                class="mx-4 white--text"
                :href="icon.link"
                target="_blank"
                icon
                >

                

                    <v-icon size="24px">{{ icon.text }}</v-icon>
                </v-btn>
            </v-card-text>

            <v-card-text class="white--text pt-0">
                Copyright ©{{ new Date().getFullYear() }} Todos los Derechos Reservados| Desarrollado por 
                <a href="https://kwsoluciones.com" target="_blank" class="white--text">kwsoluciones.com</a>   +58 412 0694916 <br/>
            </v-card-text>

            <v-divider></v-divider>

            <v-card-text class="white--text">
                {{ new Date().getFullYear() }} — <strong>kwsoluciones</strong>
            </v-card-text>
        </v-card>
    </v-footer>
</template>



<script>
    export default {
        data: () => ({
            icons: [
                {text: "mdi-facebook", link: "https://instagram.com/spaciovzla/"},
                // {text: "mdi-twitter",  link: ""},
                {text: "mdi-linkedin", link: ""},
                {text: "mdi-instagram", link: "https://instagram.com/spaciovzla/"},
            ],
        }),
    };
</script>




<style scoped>
    .v-card {
        width: 100%;
    }
</style>
